import FingerprintJS from '@fingerprintjs/fingerprintjs';
const fpPromise = FingerprintJS.load()

export function getParam(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function insertScript(url) {
    var scripts = document.getElementsByTagName('script');
    for (var script of scripts) {
        if (script.src === url) {
            return;
        }
    }
    var a = document.createElement('script');
    a.async = 1;
    if (url) {
        a.src = url;
    }
    document.head.appendChild(a);
}

export function insertLink(url) {
    var links = document.getElementsByTagName('link');
    for (var link of links) {
        if (link.href === url) {
            return;
        }
    }
    var a = document.createElement('link');
    a.rel = 'stylesheet';
    if (url) {
        a.href = url;
    }
    document.head.appendChild(a);
}


export function getShareLink(user) {
    if (!user || !user.id) return '';
    return window.location.href.split("?")[0] + "?wref=" + user.id;
}

export function saveRefToCookie() {
    var refId = getParam("wref");
    var oldRef = getCookie("wref");
    // Don't override ref & prevent self-ref
    if (refId && !oldRef) {
        setCookie("wref", refId, 7);
    }
}

export function copyToClipboard(el) {
    // resolve the element
    el = (typeof el === 'string') ? document.querySelector(el) : el;

    // handle iOS as a special case
    if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {

        // save current contentEditable/readOnly status
        var editable = el.contentEditable;
        var readOnly = el.readOnly;

        // convert to editable with readonly to stop iOS keyboard opening
        el.contentEditable = true;
        el.readOnly = true;

        // create a selectable range
        var range = document.createRange();
        range.selectNodeContents(el);

        // select the range
        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        el.setSelectionRange(0, 999999);

        // restore contentEditable/readOnly to original state
        el.contentEditable = editable;
        el.readOnly = readOnly;
    } else {
        el.select();
    }

    // execute copy command
    document.execCommand('copy');
}


export function showToast(msg, type = 'warning', options) {
    const defaults = {
        duration: 2000,
        fadeDuration: 200
    }
    const opt = Object.assign(defaults, options || {});
    vanillaToast[type](msg, opt);
}

export async function getFingerprint() {
    const fp = await fpPromise
    const result = await fp.get({
        preprocessor: (key, value) => {
            return (key == "userAgent") ? removeMinorAndPathVersion(value) : value;
        }
    })
    return result.visitorId;
}

function removeMinorAndPathVersion(string) {
    let regex_brow = /(\/\d+)([\.\d]+)/g;
    let regex_OS = /(\ \d+)([\_\d]+)/g;
    return string.replace(regex_brow, `$1`).replace(regex_OS, `$1`);
}